import * as swcHelpers from '@swc/helpers';

// We need to dynamically verify the address we get back from google. A failing streetnumber is OK, since it can be contained in the first address line
// On all other validation errors, the payment should be aborted.
const mapGooglePayContactAddress = (paymentData, type = 'shippingAddress')=>{
    var ref;
    const billingAddress = (ref = paymentData.paymentMethodData.info) === null || ref === void 0 ? void 0 : ref.billingAddress;
    var ref1;
    const [firstName = '', ...lastNameParts] = ((ref1 = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.name) !== null && ref1 !== void 0 ? ref1 : '').split(' ');
    var ref2;
    const lastName = (ref2 = lastNameParts.join(' ').trim()) !== null && ref2 !== void 0 ? ref2 : '';
    const isShippingAddress = type === 'shippingAddress';
    const address = isShippingAddress ? paymentData.shippingAddress : billingAddress;
    var ref3, ref4, ref5, ref6;
    return swcHelpers.objectSpread({
        firstName,
        lastName,
        additionalAddressInfo: address === null || address === void 0 ? void 0 : address.address1,
        streetName: (ref3 = address === null || address === void 0 ? void 0 : address.address1) !== null && ref3 !== void 0 ? ref3 : '',
        postalCode: (ref4 = address === null || address === void 0 ? void 0 : address.postalCode) !== null && ref4 !== void 0 ? ref4 : '',
        city: (ref5 = address === null || address === void 0 ? void 0 : address.locality) !== null && ref5 !== void 0 ? ref5 : '',
        countryCode: (ref6 = address === null || address === void 0 ? void 0 : address.countryCode) !== null && ref6 !== void 0 ? ref6 : ''
    }, (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.phoneNumber) ? {
        phone: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.phoneNumber
    } : {}, paymentData.email ? {
        email: paymentData.email
    } : {}, (address === null || address === void 0 ? void 0 : address.administrativeArea) ? {
        region: address === null || address === void 0 ? void 0 : address.administrativeArea
    } : {}, (address === null || address === void 0 ? void 0 : address.address2) ? {
        additionalAddressInfo: address.address2
    } : {});
};

export { mapGooglePayContactAddress };
//# sourceMappingURL=google-pay-contact-address.js.map
